import {AnalysisGraphQL, AnalysisViewGraphQL} from 'analysis-tool/AnalysisTypes';
import {
  OverflowDataViewAction,
  ButtonDataViewAction,
  CustomDataViewButton,
} from 'analysis-tool/data-view/DataViewContext';
import {AnalysisRightSidebarItem} from 'analysis-tool/right-sidebar/RightSidebarTypes';
import {AnalysisMainViewItem} from 'analysis-tool/ui/main-view/MainViewTypes';

import getAddViewAction from './getAddViewAction';
import getCopyViewAction from './getCopyViewAction';
import getDeleteViewAction from './getDeleteViewAction';
import getEditViewAction from './getEditViewAction';
import getFlaggingActions from './getFlaggingActions';
import getPromoteViewAction from './getPromoteViewAction';
import getReplaceSourceAction from './getReplaceSourceAction';

export default function getAnalysisDataViewActions(
  analysis: AnalysisGraphQL,
  analysisClientStateId: string,
  view: AnalysisViewGraphQL,
  viewStepId: string,
  selectedRowIndices: Set<number>,
  onChangeSelectedItem: (newSelectedItem: AnalysisMainViewItem) => void,
  onChangeSelectedRightSidebarItem: (newSelectedItem: AnalysisRightSidebarItem | null) => void,
  selectedRightSidebarItem: AnalysisRightSidebarItem | null
): {
  buttonActions: Array<ButtonDataViewAction | CustomDataViewButton>;
  overflowActions: Array<OverflowDataViewAction>;
} {
  return {
    buttonActions: [
      ...getFlaggingActions(analysis, view, viewStepId, selectedRowIndices),
      getAddViewAction(analysis, view, onChangeSelectedItem, onChangeSelectedRightSidebarItem),
      getEditViewAction(
        analysis,
        view,
        onChangeSelectedItem,
        onChangeSelectedRightSidebarItem,
        selectedRightSidebarItem
      ),
    ].filter((action) => action != null),
    overflowActions: [
      getReplaceSourceAction(analysis, view, onChangeSelectedItem),
      getCopyViewAction(analysis, view),
      getPromoteViewAction(analysis, view),
      getDeleteViewAction(analysis, view, analysisClientStateId),
    ].filter((action) => action != null),
  };
}
